import styled, { keyframes } from 'styled-components'

const arrive = keyframes`from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: translateY(0); }`
export const Screen = styled.main`
  font-family: Gilroy-Regular, Arial, sans-serif;
  width: 100%; max-width: 1000px; margin: auto; text-align: center;
  padding: clamp(24px, 5vh, 64px) 0 0;
  color: ${p => p.theme.palette.colors.text};
  animation: ${arrive} 380ms ease-out both;
  @media (prefers-reduced-motion: reduce) { animation: none; }
`
export const Eyebrow = styled.p`
  margin: 0 0 18px; font-size: 12px; font-weight: 600; letter-spacing: .2em;
  text-transform: uppercase; color: ${p => p.theme.palette.colors.subdued};
`
export const Heading = styled.h1`
  font-family: Gilroy; font-size: clamp(30px, 4vw, 46px); line-height: 1.12;
  font-weight: 700; letter-spacing: -.035em; margin: 0 0 16px;
`
export const Subtitle = styled.p`
  margin: 0 auto; max-width: 540px; font-size: 16px; line-height: 1.6;
  color: ${p => p.theme.palette.colors.muted};
`
export const Areas = styled.div`
  display: flex; justify-content: center; gap: clamp(24px, 5vw, 64px);
  margin: 48px auto 40px;
  @media (max-width: 560px) { flex-direction: column; gap: 16px; margin: 28px auto; max-width: 380px; }
`
export const Artwork = styled.span`
  display: grid; place-items: center; width: 176px; height: 176px;
  margin: 0 auto 24px; border-radius: 32px;
  background: ${p => p.theme.palette.colors.surfaceElevated};
  border: 1px solid ${p => p.theme.palette.colors.borderSoft};
  transition: border-color 180ms ease, transform 180ms ease, box-shadow 180ms ease;
  img { filter: ${p => p.theme.mode === 'dark' ? 'brightness(0) invert(1)' : 'none'}; }
  @media (max-width: 560px) {
    grid-row: 1 / 4; width: 88px; height: 88px; margin: 0; border-radius: 20px;
    img { width: 56px; height: 56px; }
  }
`
export const AreaName = styled.span`
  display: block; font-family: Gilroy; font-size: 25px; font-weight: 700; margin-bottom: 8px;
  @media (max-width: 560px) { font-size: 22px; margin-bottom: 0; }
`
export const Description = styled.span`
  display: block; font-size: 13px; line-height: 1.6; min-height: 42px;
  color: ${p => p.theme.palette.colors.subdued}; max-width: 210px; margin: 0 auto;
  @media (max-width: 560px) { margin: 0; min-height: 0; max-width: none; font-size: 12px; }
`
export const Enter = styled.span`
  display: inline-flex; align-items: center; gap: 10px; margin-top: 16px;
  font-size: 13px; font-weight: 600; color: ${p => p.theme.mode === 'dark' ? p.theme.palette.colors.lightBlue : p.theme.palette.blue.main};
  span { display: inline-block; transition: transform 180ms ease; }
  @media (max-width: 560px) { margin-top: 4px; }
`
export const AreaButton = styled.button`
  appearance: none; border: 0; padding: 8px; width: 232px; border-radius: 12px;
  background: transparent; color: inherit; font: inherit; cursor: pointer;
  &:hover:not(:disabled) ${Artwork}, &:focus-visible ${Artwork} {
    border-color: ${p => p.theme.palette.blue.main}; transform: translateY(-5px);
    box-shadow: 0 12px 28px ${p => p.theme.palette.colors.shadow};
  }
  &:hover:not(:disabled) ${Enter} span { transform: translate(2px, -2px); }
  &:focus-visible { outline: 2px solid ${p => p.theme.palette.blue.main}; outline-offset: 6px; }
  &:disabled { cursor: wait; opacity: .6; }
  @media (max-width: 560px) {
    width: 100%; display: grid; grid-template-columns: 88px 1fr;
    column-gap: 20px; align-items: center; text-align: left;
  }
  @media (prefers-reduced-motion: reduce) { &, * { transition: none !important; transform: none !important; } }
`
export const Footer = styled.footer`
  display: flex; align-items: center; justify-content: center; flex-direction: column; gap: 10px;
  button { font-family: inherit; }
  padding-top: 24px; border-top: 1px solid ${p => p.theme.palette.colors.borderSoft};
  max-width: 480px; margin: 0 auto; font-size: 12px; color: ${p => p.theme.palette.colors.subdued};
`
export const Message = styled.div`
  margin: 24px auto; max-width: 480px; line-height: 1.6; color: ${p => p.theme.palette.colors.muted};
`
export const Skeleton = styled.div`
  width: 176px; height: 176px; border-radius: 32px;
  background: ${p => p.theme.palette.colors.surfaceElevated};
  @media (max-width: 560px) { width: 100%; height: 88px; border-radius: 20px; }
`
